import { useEffect, useRef } from "react";

/**
 * Guarantees via a ref that the effect is only called once, on mount:
 *
 * useRunOnMountEffect(() => {
 *   ...do something only once
 * });
 *
 * @param callback
 */
type Effect = Parameters<typeof useEffect>[0];
export const useRunOnMountEffect = (effect: Effect) => {
  const hasEffectBeenCalled = useRef(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(hasEffectBeenCalled ? effect : () => undefined, []);
};
